module.exports = __webpack_public_path__ + "img/F968.b4a6b542.jpg";